import { useRequiredParams } from '@pba/react-router';
import { AppLayout } from 'layouts';
import { ActivityDetail } from 'features/feed';

type RouteParams = {
  postId: string;
};

const PageActivity = () => {
  const { postId } = useRequiredParams<RouteParams>();

  return (
    <AppLayout aside>
      <ActivityDetail postId={postId} />
    </AppLayout>
  );
};

export default PageActivity;
